import React from "react";
import {IntlShape} from "react-intl";
import {DataTableColumnProps} from "peggirkit";
import {RestaurantSyncLog, SyncStatus} from "@/data/entities/sync";
import StatusFormatter from "./formatters/StatusFormatter";
import {formatDateTimeSeconds} from "@/utils/DateUtils";


export const columnCreationDate = (intl: IntlShape): DataTableColumnProps<RestaurantSyncLog> => ({
    id: "creationDate",
    label: {displayName: intl.formatMessage({id: "date"})},
    primary: true,
    sortingConfig: {
        enabled: true,
        sorted: "desc",
    },
    formatter: date => formatDateTimeSeconds(date),
});

export const columnStatus = (intl: IntlShape): DataTableColumnProps<RestaurantSyncLog> => ({
    id: "status",
    label: {displayName: intl.formatMessage({id: "status"})},
    align: "right",
    sortingConfig: {
        enabled: false,
    },
    formatter: (status: SyncStatus) => <StatusFormatter status={status}/>,
});

export const columnDescription = (intl: IntlShape): DataTableColumnProps<RestaurantSyncLog> => ({
    id: "description",
    label: {displayName: intl.formatMessage({id: "log"})},
    sortingConfig: {
        enabled: true,
    },
});

export const columnRestaurantName = (intl: IntlShape): DataTableColumnProps<RestaurantSyncLog> => ({
    id: "restaurant",
    label: {displayName: intl.formatMessage({id: "location"})},
    align: "right",
    sortingConfig: {
        enabled: false,
    },
    formatter: restaurant => restaurant.name,
});

export const getSynchronizationLogsDataTableColumns = (intl: IntlShape): DataTableColumnProps<RestaurantSyncLog>[] => ([
    columnCreationDate(intl),
    columnDescription(intl),
    columnStatus(intl),
    columnRestaurantName(intl),
]);
